"use client";
import { useContext, useEffect, useState } from "react";
import Input from "../Input";
import Select from "../Select";
import { GlobalContext } from "@/context";
import axios from "../../app/lib/axiosInstance";

const Livraison = () => {
  const { connected, userData, setPanierStatus } = useContext(GlobalContext);

  const getAdress = async () => {
    if (connected && userData) {
      const data = await axios
        .get("/adress/getaddress", {
          headers: {
            "Content-Type": "application/json",
          },
          withCredentials: true,
        })
        .then((res) => res.data)
        .then((res) => {
          setAdressId(res.adress._id ? res.adress._id : "");
          setAdress(res.adress.adress ? res.adress.adress : "");
          setRue(res.adress.street ? res.adress.street : "");
          setCodePostal(res.adress.codePostal ? res.adress.codePostal : "");
          setVille(res.adress.city ? res.adress.city : "");
          setPhoneNumber(res.adress.phoneNumber ? res.adress.phoneNumber : "");
        })
        .catch((err) => {
          setAdress("");
          setRue("");
          setCodePostal("");
          setVille("");
          setPhoneNumber("");
        });
    } else {
      setAdress("");
      setRue("");
      setCodePostal("");
      setVille("");
      setPhoneNumber("");
    }
  };

  const updateAdress = async () => {
    if (adressId) {
      if (adress && rue && codePostal && ville && phoneNumber) {
        const data = await axios
          .put(
            `/adress/updateaddress`,
            {
              adress: adress,
              city: ville,
              street: rue,
              codePostal: codePostal,
              phoneNumber: phoneNumber,
            },
            {
              headers: {
                "Content-Type": "application/json",
              },
              withCredentials: true,
            }
          )
          .then((res) => res?.data?.adressUpdated)
          .then((res) => {
            localStorage.setItem("adressId", JSON.stringify(res._id));
            setError("");
            setPanierStatus(3);
          });
      } else setError("make sure you fullfield all inputes");
    } else {
      const data = await axios
        .post(
          `/adress/post`,
          {
            adress: adress,
            city: ville,
            street: rue,
            codePostal: codePostal,
            phoneNumber: phoneNumber,
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        )
        .then((res) => res.data.adress)
        .then((res) => {
          localStorage.setItem("adressId", JSON.stringify(res._id));
          setError("");
          setPanierStatus(3);
        })
        .catch((error) => setError(error?.response?.data.error.message));
    }
  };

  useEffect(() => {
    getAdress();
  }, [connected]);

  // Initializing all states with "" or 0
  const [error, setError] = useState("");
  const [adressId, setAdressId] = useState("");
  const [adress, setAdress] = useState("");
  const [rue, setRue] = useState("");
  const [codePostal, setCodePostal] = useState(""); // Use empty string for numbers
  const [ville, setVille] = useState("");
  const [phoneNumber, setPhoneNumber] = useState(""); // Use empty string for phone number

  return (
    <div className="flex flex-col gap-20">
      <div className="w-[80%] mx-auto flex flex-col lg:flex-row gap-4 ">
        <div className="flex flex-col gap-5 w-full">
          <div className="flex flex-col gap-5 md:gap-0  md:flex-row md:justify-between justify-normal">
            <div className="flex flex-col w-full">
              <label>Adresse :</label>
              <Input
                type={"text"}
                placeholder={"Adresse"}
                width={"w-full"}
                mdwidth={"md:w-[80%]"}
                height={"!h-[48px]"}
                state={adress}
                setState={setAdress}
                myLabel={"Adresse"}
              />
            </div>
            <div className="flex flex-col w-full">
              <label>Numéro de téléphone :</label>
              <Input
                type={"number"}
                placeholder={"Numéro de téléphone* "}
                width={"w-full"}
                mdwidth={"md:w-[80%]"}
                height={"!h-[48px]"}
                state={phoneNumber}
                setState={setPhoneNumber}
              />
            </div>
          </div>
          <div className="flex flex-col gap-5 md:gap-0  md:flex-row md:justify-between justify-normal">
            <div className="flex flex-col w-full">
              <label>Ville:</label>
              <Select
                state={ville}
                setState={setVille}
                placeholder={"Ville"}
                md={"w-[80%]"}
                height={"!h-[48px]"}
                options={[
                  ["tunis", "Tunis"],
                  ["sfax", "Sfax"],
                  ["sousse", "Sousse"],
                  ["kairouan", "Kairouan"],
                  ["monastir", "Monastir"],
                  ["gabes", "Gabes"],
                  ["nabeul", "Nabeul"],
                  ["ben_aarous", "Ben Arous"],
                  ["zaghouan", "Zaghouan"],
                  ["bizerte", "Bizerte"],
                  ["kasserine", "Kasserine"],
                  ["tozeur", "Tozeur"],
                  ["beja", "Béja"],
                  ["siliana", "Siliana"],
                  ["jendouba", "Jendouba"],
                  ["tataouine", "Tataouine"],
                  ["gafsa", "Gafsa"],
                  ["el_ksar", "El Ksar"],
                  ["ariana", "Ariana"],
                  ["le_kef", "Le Kef"],
                  ["mahdia", "Mahdia"],
                  ["manouba", "Manouba"],
                  ["sidi_bouzid", "Sidi Bouzid"],
                  ["medenine", "Medenine"],
                ]}
              />
            </div>
            <div className="flex flex-col w-full">
              <label>Code Postal :</label>
              <Input
                type={"number"}
                placeholder={"code postal*"}
                width={"w-full"}
                mdwidth={"md:w-[250px]"}
                height={"!h-[48px]"}
                state={codePostal}
                setState={setCodePostal}
              />
            </div>
          </div>
          <div className="flex flex-col w-full">
            <label>Rue :</label>
            <Input
              type={"text"}
              placeholder={"Rue*"}
              width={"w-full"}
              mdwidth={"md:w-[40%]"}
              height={"!h-[48px]"}
              state={rue}
              setState={setRue}
            />
          </div>
          <h2 className="text-[#CC0001] font-semibold underline">
            {error ? error : null}
          </h2>
        </div>
      </div>
      <button
        className="text-[#FFFFFF] uppercase bg-[#CC0001] text-base px-4 w-fit self-end mx-auto md:mr-28 rounded-[19px] py-3"
        onClick={() => {
          updateAdress();
        }}
      >
        valider mon adress
      </button>
    </div>
  );
};

export default Livraison;
